// Identity policies: the caller's own record, tenant memberships, invitations.
import { allOf, anyOf, isMember, isRole, isSelf, not } from '../policy/rules.js';
const tenantAdmin = isRole('TenantAdmin');
export const mePolicy = {
    kind: 'me',
    scope: 'tenant',
    actions: {
        read: allOf(isMember, isSelf('sub')),
        /** Accepting a document is the person's own act, for themselves only. */
        consent: allOf(isMember, isSelf('sub')),
    },
};
export const membershipPolicy = {
    kind: 'membership',
    scope: 'tenant',
    actions: {
        list: tenantAdmin,
        read: anyOf(tenantAdmin, isSelf('sub')),
        update: tenantAdmin,
        /** An admin cannot remove themselves: the last admin must hand over first. */
        remove: allOf(tenantAdmin, not(isSelf('sub'))),
    },
};
export const invitationPolicy = {
    kind: 'invitation',
    scope: 'tenant',
    actions: {
        list: tenantAdmin,
        create: tenantAdmin,
        read: tenantAdmin,
        revoke: tenantAdmin,
        resend: tenantAdmin,
    },
};
//# sourceMappingURL=identity.js.map